/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CancellationReasonChoice {
  MISSING_FEATURES = 'missing_features',
  PRODUCT_FEATURE_ISSUES = 'product_feature_issues',
  FOUND_BETTER_ALTERNATIVE = 'found_better_alternative',
  TOO_EXPENSIVE = 'too_expensive',
  DONT_KNOW_HOW_TO_USE = 'dont_know_how_to_use',
  NO_LONGER_NEED_PRODUCT = 'no_longer_need_product',
  OTHER = 'other',
}
